export default function React_FormsSubmit() {
  return (
    <div>
      <h1>React_FormsSubmit Component</h1>
      <p>This is the React_FormsSubmit tutorial page.</p>
    </div>
  );
}
